import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { getBrandCtaColorName } from "/services/brand-service";
import LaddaButton, { XL, ZOOM_IN } from "react-ladda";
import classnames from "classnames";
import { WORK_OS_IRIS_COLOR_NAME, GRADIANT_WORKOS_IRIS_COLOR_NAME, BRAND_BLACK_TEXT_COLOR, WORKFORMS_RED_COLOR_NAME, DARK_MARKETING_RED_COLOR_NAME, DARK_CRM_GREEN_COLOR_NAME, CRM_GREEN_COLOR_NAME, DARK_PROJECTS_ORANGE_COLOR_NAME, DARK_DEV_GREEN_COLOR_NAME, CRM_DARK_TINT_01_COLOR_NAME, BRAND_GREEN_DARK_TINT_01_COLOR_NAME, BRAND_DARK_COLOR_NAME, BRAND_BLACK_BACKGROUND_COLOR, BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME, CRM_DARKER_TINT_02_COLOR_NAME, DEV_DARKER_TINT_02_COLOR_NAME, BRAND_PRIMARY_GREEN_COLOR_NAME, BRAND_WORK_MANAGEMENT_DARKER_TINT_COLOR_NAME, DEV_PRIMARY_COLOR_NAME, CRM_PRIMARY_COLOR_NAME, BRAND_SERVICE_PRIMARY_COLOR_NAME, CRM_CTA_COLOR_NAME, DEV_CTA_COLOR_NAME, SERVICE_CTA_COLOR_NAME, VIVID_BLUE_COLOR_NAME } from "styles/color-consts";
import colors from "styles/colors";
import ButtonArrow from "segments/desktop/core-components/button/button-arrow/button-arrow";
import { StyledButtonComponent } from "./button-component.scss";
export const SUPPORTED_BUTTON_COLORS = [
    "blue",
    "outline-blue",
    "outline-dark-blue",
    "outline-dark-blue-inverted-hover",
    "outline-indigo-inverted-hover",
    "brand-blue",
    "brand-red",
    "brand-green",
    "brand-yellow",
    "brand-purple",
    "brand-iris",
    "green",
    "purple",
    "iris",
    "yellow",
    "royal",
    "orange",
    "dodger-blue",
    "white",
    "white-iris",
    "white-dodger",
    BRAND_BLACK_TEXT_COLOR,
    CRM_DARKER_TINT_02_COLOR_NAME,
    BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME,
    DEV_DARKER_TINT_02_COLOR_NAME,
    BRAND_PRIMARY_GREEN_COLOR_NAME,
    BRAND_BLACK_BACKGROUND_COLOR,
    GRADIANT_WORKOS_IRIS_COLOR_NAME,
    WORKFORMS_RED_COLOR_NAME,
    DARK_MARKETING_RED_COLOR_NAME,
    DARK_CRM_GREEN_COLOR_NAME,
    CRM_GREEN_COLOR_NAME,
    DARK_PROJECTS_ORANGE_COLOR_NAME,
    DARK_DEV_GREEN_COLOR_NAME,
    CRM_DARK_TINT_01_COLOR_NAME,
    BRAND_GREEN_DARK_TINT_01_COLOR_NAME,
    BRAND_DARK_COLOR_NAME,
    WORK_OS_IRIS_COLOR_NAME,
    BRAND_WORK_MANAGEMENT_DARKER_TINT_COLOR_NAME,
    DEV_PRIMARY_COLOR_NAME,
    CRM_PRIMARY_COLOR_NAME,
    BRAND_SERVICE_PRIMARY_COLOR_NAME,
    CRM_CTA_COLOR_NAME,
    DEV_CTA_COLOR_NAME,
    SERVICE_CTA_COLOR_NAME,
    VIVID_BLUE_COLOR_NAME
];
const DEFAULT_COLOR = "dodger-blue";
/** @deprecated - use components/core/new-button/button instead */ const ButtonComponent = (props)=>{
    var _useContext;
    const [isHovered, setIsHovered] = useState(false);
    const [startPaintAnimation, setStartPaintAnimation] = useState(true);
    const { color, className, size, isLoading, onClickCallback, children, type, disabled, disableAnimation, dataSpinnerColor, invert, withBorder, hasArrow, paintButtonColor, buttonAlign } = props;
    // Purple CTAs are black (`Black`, also a supported color) on the new brand; nothing changes off-brand.
    const isNewBrand = (_useContext = useContext(GenericConfigContext)) === null || _useContext === void 0 ? void 0 : _useContext.isNewBrand;
    const brandColor = getBrandCtaColorName(color, isNewBrand);
    const buttonColor = SUPPORTED_BUTTON_COLORS.indexOf(brandColor) !== -1 ? brandColor : DEFAULT_COLOR;
    useEffect(()=>{
        if (paintButtonColor) {
            setStartPaintAnimation(true);
            setTimeout(()=>{
                setStartPaintAnimation(false);
            }, 1000);
        }
    }, [
        paintButtonColor
    ]);
    return /*#__PURE__*/ _jsx(StyledButtonComponent, {
        className: classnames(`ladda-button-component ${buttonAlign}`),
        buttonColor: buttonColor,
        children: /*#__PURE__*/ _jsxs(LaddaButton, {
            className: classnames(`${className} ${buttonColor} ${size}`, {
                invert,
                "disable-animation": disableAnimation,
                "with-border": withBorder,
                "has-arrow": hasArrow,
                "has-paint-animation": paintButtonColor
            }),
            "data-style": ZOOM_IN,
            "data-size": XL,
            "data-spinner-color": dataSpinnerColor,
            onClick: onClickCallback,
            type: type,
            loading: isLoading,
            disabled: disabled || isLoading,
            "data-button-color": buttonColor,
            onMouseEnter: ()=>setIsHovered(true),
            onMouseLeave: ()=>setIsHovered(false),
            children: [
                children,
                hasArrow && /*#__PURE__*/ _jsx(ButtonArrow, {
                    size: size,
                    hover: isHovered,
                    isSignup: true
                }),
                paintButtonColor && /*#__PURE__*/ _jsx("span", {
                    className: classnames("paint-overlay", {
                        "start-animating": startPaintAnimation
                    }),
                    style: {
                        "--signup-paint-animation-color": colors[paintButtonColor]
                    }
                })
            ]
        })
    });
};
ButtonComponent.defaultProps = {
    isLoading: false,
    disableAnimation: false,
    onClickCallback: ()=>{},
    className: "",
    type: "button",
    withBorder: false
};
export default ButtonComponent;
